import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import store from '../store'
import translation_en from './en.json';
import translation_zh from './zh.json';
import translation_es from './es.json';
import translation_fr from './fr.json';
import translation_ko from './ko.json';
import translation_ja from './ja.json';
import translation_ar from './ar.json';
import translation_ru from './ru.json';


const resources = {
    en: {
        translation: translation_en,
    },
    zh: {
        translation: translation_zh,
    },
    es: {
        translation: translation_es,
    },
    fr: {
        translation: translation_fr,
    },
    ko: {
        translation: translation_ko,
    },

    ja: {
        translation: translation_ja,
    },
    ar: {
        translation: translation_ar,
    },
    ru: {
        translation: translation_ru,
    },
};

const lan =  "en"
// store.dispatch({type:'setLan',value:lan})

i18n.use(initReactI18next).init({
    resources,
    lng: lan,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
